module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-step-wrap no-select"
  }, _vm._l((_vm.flow.steps), function(step, key) {
    return _c('div', {
      staticClass: "circle",
      class: {
        actived: _vm.flow.actived == key, finish: key <= _vm.finish
      }
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(key))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5751425e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets/flowStep.vue
// module id = 569
// module chunks = 1